import { render, staticRenderFns } from "./StackLayers.vue?vue&type=template&id=046f2fb4&scoped=true"
import script from "./StackLayers.vue?vue&type=script&lang=js"
export * from "./StackLayers.vue?vue&type=script&lang=js"
import style0 from "./StackLayers.vue?vue&type=style&index=0&id=046f2fb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046f2fb4",
  null
  
)

export default component.exports